import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organizational-functions',
  templateUrl: './organizational-functions.component.html',
  styleUrls: ['./organizational-functions.component.scss']
})
export class OrganizationalFunctionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
